import { connect } from "react-redux";
import { actions } from "../../../../../redux/modules/reportes/notas_credito_cliente";
import ListadoNotasCreditoCliente from "./ListadoNotasCreditoCliente";

const ms2p = (state) => {
    return {
        ...state.reporte_nc_cliente,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListadoNotasCreditoCliente);
